if (!window.Eurus.loadedScript.has('product-sibling.js')) {
  window.Eurus.loadedScript.add('product-sibling.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductSibling", (sectionId, isProductPage, redirect, updateUrl = true) => ({
        cachedResults: [],
        updateProductInfo(url) {
          if (redirect) {
            window.location.href = url;
            return
          }
          let link = url;
          if (!isProductPage) {
            const parsed = new URL(url, window.location.origin);
            parsed.searchParams.set('section_id', sectionId);
            parsed.searchParams.set('page', '25000');
            link = `${parsed.pathname}${parsed.search}`;
          }
      
          if (this.cachedResults[link]) {
            const html = this.cachedResults[link];
            this._updateTitle(html);
            this._handleSwapProduct(html);
            this._updateFbtContainer(html);
          } else {
            fetch(link)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              this._updateTitle(html);
              this._handleSwapProduct(html);
              this._updateFbtContainer(html)
              this.cachedResults[link] = html;
            })
          }
          this._updateURL(url);
        },
        changeSelectOption(event) {
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          this.updateProductInfo(targetUrl);
        },
        _updateURL(url) {
          if (!isProductPage || !updateUrl || !url) return;
          const next = new URL(url, window.location.origin);
          const current = new URL(window.location.href);
          current.searchParams.forEach((value, key) => {
            if (!next.searchParams.has(key)) next.searchParams.append(key, value);
          });
          const qs = next.searchParams.toString();
          const hash = next.hash || current.hash;
          window.history.replaceState({}, '', `${next.pathname}${qs ? `?${qs}` : ''}${hash}`);
        },
        _updateTitle(html) {
          if (!isProductPage) return;
          document.querySelector('head title').textContent = html.querySelector('.product-title').textContent;
          const destination = document.getElementById('breadcrumbs--' + sectionId);
          const source = html.getElementById('breadcrumbs--' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _updateFbtContainer(html) {
          if (!isProductPage) return;
          const destination = document.getElementById('popup-fbt-' + sectionId);
          const source = html.getElementById('popup-fbt-' + sectionId);
          if (source && destination) destination.outerHTML = source.outerHTML;
        },
        _handleSwapProduct(html) {
          const destination = isProductPage ? document.querySelector('.main-product') : document.querySelector('.x-product-' + sectionId);
          const source = isProductPage ? html.querySelector('.main-product') : html.querySelector('.x-product-' + sectionId);
          if (source && destination) {
            if (!isProductPage) destination.id = source.id;
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}